import { iConfigColumn } from '../../shared/UITypes/types';

export const CLONE_THIS_ORDER = 'Clone order';
export const DELETE_THIS_ORDER = 'Delete order';
export const COMPANY_TYPE_SUPPLIER = 'supplier';
export const COMPANY_TYPE_CUSTOMER = 'customer';
export const PO_RECEIVES_TABLE_NAME = 'PO_RECEIVES_TABLE';
export const PO_RECEIVES_TABLE_TEST_ID = 'PO_RECEIVES_TABLE';
export const PO_RECEIVES_DOCKET_NUMBER_ALIAS = 'Delivery Docket No. / Ref.';
export const PO_RECEIVED_PRODUCTS_TABLE_NAME = 'PO_RECEIVED_PRODUCTS_TABLE';
export const PO_RECEIVED_PRODUCTS_TABLE_TEST_ID = 'PO_RECEIVED_PRODUCTS_TABLE';
export const COLUMNS_AFTER = ['Operation'];
export const PO_TABLE_NAME = 'purchaseOrder-table';
export const PO_TABLE_TEST_ID = 'purchaseOrder-table';

export const PO_RECEIVING_STATUS_CLOSED_CATEGORY = 'STATUS_CATEGORY_FINISHED';
export const PO_STATUS_WIP_CATEGORY = 'STATUS_CATEGORY_IN_PROGRESS';

export const COLUMN_NAMES = ['PO No.', 'Status', 'Reference', 'Supplier', 'ETA', 'Total Amt.', 'Created', 'Updated'];

export const PURCHASE_ORDER_ITEM_TABLE_COLUMNS = [
  'Product Code / SKU',
  'Supplier Product Code',
  'Description',
  'Quantity',
  'Unit Price',
  'Disc %',
  'Tax',
  'Total (Inc GST)',
];

export const PO_RECEIVES_TABLE_FLEX_COLUMNS = ['Status', 'No of Line Items', 'Attachments', 'Created', 'Updated'];
export const PO_RECEIVES_TABLE_COLUMNS = [
  PO_RECEIVES_DOCKET_NUMBER_ALIAS,
  ...PO_RECEIVES_TABLE_FLEX_COLUMNS,
  // ...COLUMNS_AFTER,
];

export const PO_RECEIVED_PRODUCTS_TABLE_COLUMNS = [
  {
    name: 'Product Code / SKU',
    key: 'product.productCode',
    dataSource: ['productId', 'product.name'],
    isCompulsory: true,
    isSortable: false,
    type: 'text-two-layer',
    urlPrefix: '/b/product',
    isSelected: true,
    group: '',
  },
  {
    name: PO_RECEIVES_DOCKET_NUMBER_ALIAS,
    key: 'purchaseOrderReceiving.reference',
    dataSource: ['purchaseOrderReceiving.id'],
    type: 'link',
    urlPrefix: '/b/purchases/receiving',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Supplier Product Code',
    key: 'purchaseOrderItem.supplierProductCode',
    dataSource: ['purchaseOrderItem.id'],
    type: 'text',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Quantity',
    key: 'qty',
    dataSource: [
      'qty',
      'purchaseOrderItem.measurement.shortName',
      'purchaseOrderItem.unitConversion',
      'product.measurement.shortName',
    ],
    type: 'qty',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'To Location',
    key: 'toWarehouseLocation.name',
    dataSource: ['toWarehouseLocationId', 'toWarehouseLocation.locationCode'],
    type: 'text-two-layer',
    urlPrefix: '/b/warehouse',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Lot / Batch No.',
    key: 'reference',
    dataSource: ['reference'],
    type: 'text',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Created',
    key: 'createdAt',
    dataSource: ['createdBy.firstName'],
    type: 'history',
    group: '',
    isSortable: false,
  },
  {
    name: 'Updated',
    key: 'updatedAt',
    dataSource: ['updatedBy.firstName'],
    type: 'history',
    group: '',
    isSortable: false,
  },
];

export const PO_COLUMNS: Array<iConfigColumn> = [
  {
    name: 'Order No.',
    key: 'orderNumber',
    dataSource: ['id'],
    isCompulsory: true,
    isSortable: true,
    type: 'link',
    urlPrefix: '/b/purchases',
    isSelected: true,
    group: '',
  },
  {
    name: 'Status',
    key: 'status',
    dataSource: ['status'],
    type: 'status',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Reference',
    key: 'supplierRef',
    dataSource: ['supplierRef'],
    type: 'text',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Supplier',
    key: 'supplier.name',
    dataSource: ['supplier.id'],
    urlPrefix: '/b/supplier',
    type: 'text',
    isSelected: true,
    group: '',
    isSortable: false,
  },
  {
    name: 'Order Date',
    key: 'orderDate',
    dataSource: ['orderDate'],
    type: 'date',
    isSelected: false,
    group: '',
    isSortable: false,
  },
  {
    name: 'ETA',
    key: 'eta',
    dataSource: ['eta'],
    type: 'date',
    isSelected: true,
    group: '',
    isSortable: true,
  },
  {
    name: 'Total Amt.',
    key: 'totalAmt',
    dataSource: ['totalAmt'],
    type: 'money',
    isSelected: false,
    group: '',
    isSortable: false,
  },
  {
    name: 'Created',
    key: 'createdAt',
    dataSource: ['createdBy.firstName'],
    type: 'history',
    group: '',
    isSortable: false,
  },
  {
    name: 'Updated',
    key: 'updatedAt',
    dataSource: ['updatedBy.firstName'],
    type: 'history',
    group: '',
    isSortable: false,
  },
  {
    name: '',
    key: 'operation',
    dataSource: [],
    type: 'operation',
    isCompulsory: true,
    isSelected: true,
    group: '',
  },
];
